
import { defineComponent, computed } from "vue";
import { useStore } from "vuex";

// import KTNotificationsMenu from "@/layout/header/partials/NotificationsMenu.vue";
// import KTQuickLinksMenu from "@/layout/header/partials/QuickLinksMenu.vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";
import UserInfo from "@/composables/user-info";
export default defineComponent({
  name: "topbar",

  components: {
    // KTNotificationsMenu,

    KTUserMenu,
  },

  setup() {
    const store = useStore();
    const { initials, plan, planComp, createdAt, planId } = UserInfo();

    const daysOfCreatedAt = computed(() => {
      let date = new Date(store.getters.currentUser.createdAt);
      let now = new Date();
      let diff = now.getTime() - date.getTime();
      let days = diff / (1000 * 3600 * 24);
      return Math.ceil(days);
    });

    const isExpired = computed(() => {
      if (planId.value === "6154ad7d184f454150d7bf97") {
        if (daysOfCreatedAt.value > 15) {
          return false;
        }
      } else {
        return true;
      }
    });

    return {
      initials,
      plan,
      planComp,
      createdAt,
      planId,
      isExpired,
      daysOfCreatedAt,
    };
  },
});
